// The size of a client as the sales plan counts it (« Tableau pilotage »):
// a key account, an SME or a very small business. On a company record the
// api decides it (company/crm: size, sizeSource, etp): a prospect keeps the
// one chosen by hand, a client takes its own from its missions under way
// today against the thresholds of the admin console. Labels live in the
// locales (clientSizes).
export const CLIENT_SIZES = ['grand_compte', 'pme', 'tpe'];

export const clientSizeLabel = (language, size) =>
  size ? language.getValue(`clientSizes.${size}`, '') : '';

// `thresholds`: the ETP from which a client is a key account, then an SME;
// below, a very small business.
export const sizeFromEtp = (etp, thresholds) => {
  if (etp == null) return null;
  if (etp >= thresholds.grand_compte) return 'grand_compte';
  if (etp >= thresholds.pme) return 'pme';
  return 'tpe';
};
